import React from "react";
import Modal from "./Modal";

interface ConfirmationModalProps {
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                 title,
                                                                 message,
                                                                 onConfirm,
                                                                 onCancel,
                                                                 confirmText = "Confirm",
                                                                 cancelText = "Cancel",
                                                             }) => {
    return (
        <Modal onClose={onCancel}>
            <div className="text-center p-6 rounded-md">
                <h2 className="text-xl font-bold mb-4">{title}</h2>
                <p className="mb-6">{message}</p>
                <div className="flex justify-center space-x-4">
                    <button
                        onClick={onConfirm}
                        className="bg-red-500 text-white rounded-md px-6 py-2 hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700"
                    >
                        {confirmText}
                    </button>
                    <button
                        onClick={onCancel}
                        className="bg-gray-300 text-gray-800 rounded-md px-6 py-2 hover:bg-gray-400 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
                    >
                        {cancelText}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;